module.exports = __webpack_public_path__ + "img/project_icon_four.467b1c05.png";